/**
 * Earning-base codes from the backend `valumize.asset.EarningBase` code table
 * (see {@link CodeTableEnum.ASSET_EARNING_BASE}). The values mirror the canonical
 * uppercase codes the server stores, so they can be compared directly against an
 * asset valuation's or investment record's `earningBase.code`.
 */
export enum EarningBaseCode {
    EBT = "EBT",
    EBIT = "EBIT",
    EBITA = "EBITA",
    EBITDA = "EBITDA",
    EBITDAR = "EBITDAR"
}
